let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kilYt")).then(() => parcelRequire('bi6bT'));